import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetHormoneGauge() {

  return (

      <GaugeWithNeedle realAge={70} chronologicalAge={62} />
    
  );
};




